import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { toast } from "sonner";

// Handles the return from Emergent-managed Google OAuth.
// Lands at /account/auth/callback#session_id=... — we exchange it for our client session.
export default function AccountAuthCallback() {
  const nav = useNavigate();
  const site = useSite();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : "";
    if (!sessionId) { nav("/account/login", { replace: true }); return; }
    (async () => {
      try {
        await api.post("/client/oauth/google/session", { session_id: sessionId });
        // Clear the sensitive fragment from the URL.
        window.history.replaceState({}, document.title, "/account/auth/callback");
        window.dispatchEvent(new Event("ascendia-auth-change"));
        toast.success("Signed in with Google");
        nav("/account", { replace: true });
      } catch (err) {
        setError(true);
        toast.error(err?.response?.data?.detail || "Google sign-in failed. Please try again.");
        setTimeout(() => nav("/account/login", { replace: true }), 1800);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0B0C] text-white flex flex-col items-center justify-center gap-4">
      <img src={site.logo} alt="Ascendia Detail" className="h-12 w-12 object-contain" />
      {error ? (
        <p className="text-sm text-muted-c">Sign-in didn't complete. Redirecting…</p>
      ) : (
        <p className="flex items-center gap-2 text-sm text-muted-c"><Loader2 className="h-4 w-4 animate-spin text-gold-soft" /> Completing your sign-in…</p>
      )}
    </div>
  );
}
